import {psLeakDeviceApi} from "../api/psLeakDeviceApi"
import {createFetchHook} from "./createFetchHook"
import {userApi} from "../api/userApi"
import {companyApi} from "../api/companyApi"
import {objectGroupApi} from "../api/objectGroupApi"
import {objectApi} from "../api/objectApi"
import {userGroupApi} from "../api/userGroupApi"

export const useGetCompanies = createFetchHook(companyApi.getCompanies)
export const useGetObjectGroups = createFetchHook(objectGroupApi.getObjectGroups)
export const useGetObjects = createFetchHook(objectApi.getObjects)
export const useGetDevices = createFetchHook(psLeakDeviceApi.getDevices)
export const useGetUsers = createFetchHook(userApi.getUsers)
export const useGetUserGroups = createFetchHook(userGroupApi.getUserGroups)